import PropTypes from "prop-types";
import Modal from "../modal/Modal";
import { MODAL_TYPE } from "../../constants";
import Button from "../buttons/button/Button";
import { BUTTON_TYPES } from "../buttons/button/ButtonTypes";
import styles from "./LoyaltySuccessModal.scss";

const LoyaltySuccessModal = ({ open, closeModal }) => {
  return (
    <Modal
      open={open}
      closeModal={closeModal}
      modalType={MODAL_TYPE.CENTER}
      contentLoaded
      modalId="LoyaltySuccessModal"
    >
      <div className={styles.loyaltyOptInModal}>
        <div className={styles.icon}>
          <div className="product-asos-world" />
        </div>
        <div className={styles.header}>Welcome</div>
        <div className={styles.header}>to ASOS.WORLD</div>
        <div className={styles.copy}>
          Discover the latest products, exclusive discounts and digital stylist
          with ASOS.WORLD. The best part? It’s free!
        </div>
        <Button
          type={BUTTON_TYPES.loyaltyFullWidth}
          handleClick={closeModal}
          additionalClasses={styles.startShoppingButton}
        >
          Start shopping
        </Button>
        <div className={styles.termsLinkText}>
          <a
            href="/terms-and-conditions"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ts&Cs
          </a>
          {" and "}
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          {" apply"}
        </div>
      </div>
    </Modal>
  );
};

LoyaltySuccessModal.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default LoyaltySuccessModal;
